import { useTranslation } from "react-i18next";
import { featuredCategories } from "@/mocks/categories";

export default function FeaturedSection() {
  const { t } = useTranslation();

  return (
    <section id="featured" className="w-full bg-background-50 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Hand-Picked Collections
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            {t("featured.title")}
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            {t("featured.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Pandabuy Spreadsheet ${cat.name} collection`}
                  title={`Pandabuy Spreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-lg md:text-xl text-background-50 leading-tight mb-1 drop-shadow-sm">
                    {cat.name}
                  </h3>
                  <p className="text-xs md:text-sm text-background-50/85 leading-relaxed max-w-xs drop-shadow-sm">
                    {cat.desc}
                  </p>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="inline-block px-2 py-0.5 rounded bg-background-50/90 text-foreground-800 text-xs font-medium">
                    Updated Today
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer group-hover:gap-2 transition-all duration-200">
                  Open Spreadsheet
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}